import React from 'react';
import { useTrackingContext } from '@givelify/utils';
import { styled } from '@mui/material';
import { GivelifyNotification, StateType } from '../notifications';

export const StyledNotification = styled(GivelifyNotification)(({ theme }) => ({
    marginBottom: theme.spacing(3),
}));

type ModalTopMessageProps = {
    variant: StateType;
    message: string | undefined;
};

export const ModalTopMessage: React.FCC<ModalTopMessageProps> = ({
    message,
    variant,
}) => {
    const { pageName } = useTrackingContext();
    if (!message) return null;
    return (
        <StyledNotification
            open
            aria-label={`${pageName}_notification`}
            onClose={undefined}
            text={message}
            variant={variant}
        />
    );
};
